import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { TimerFormatterComponent } from '../timer-formatter/timer-formatter.component';

@NgModule({
  imports: [
    CommonModule,
    MatInputModule,
  ],
  exports: [
    TimerFormatterComponent
  ],
  providers: [
  ],
  declarations: [
    TimerFormatterComponent
  ]
})
export class TimerFormatterModule { }
